import React from "react";
import { Controller } from "react-hook-form";

import { Toggle } from "../Toggle";
import { FormInputProps } from "./types";

export const FormToggle = ({
  name,
  control,
  label,
  description,
  rules,
  disabled,
  testId,
}: FormInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <Toggle
          label={label}
          description={description}
          checked={value}
          onChange={onChange}
          disabled={disabled}
          testId={testId}
        />
      )}
    />
  );
};
